import { render } from "./ImageListUpload.vue?vue&type=template&id=0879b8f0"
import script from "./ImageListUpload.vue?vue&type=script&lang=js"
export * from "./ImageListUpload.vue?vue&type=script&lang=js"

import "./ImageListUpload.vue?vue&type=style&index=0&id=0879b8f0&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__